<template lang="pug">
div.box
    v-server-table(
        :url="datatableUrl",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
        template(slot="beforeTable")
            datatable-loader(:name="tableName")

    receipt(ref="receipt", id="voided-receipt")
</template>

<script>
import { mapState } from 'vuex';
import Feature from '@js/plugins/feature';
import receiptMixin from '../../mixins/receipt';

export default {
    mixins: [receiptMixin],

    data() {
        var columns = [
            'voided_at',
            'settled_date',
            'sequence_number',
            'voider',
            'void_remarks',
            'till_closure',
            'till_summary',
            'cashier',
            'payment_type',
            'table_name',
            'pax',
            'total_amount',
            'outlet_name',
        ];

        if (Feature.hasFeature('retail')) {
            const fnbColumns = ['table_name', 'pax'];
            columns = columns.filter(item => !fnbColumns.includes(item));
        }

        return {
            transaction: null,
            tableName: 'VUETABLE_VOIDEDSALES',
            columns,
            options: {
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                headings: {
                    settled_date: 'Receipt Date',
                    sequence_number: 'Receipt No.',
                    table_name: 'Table',
                    outlet_name: this.trans('general.outlet'),
                    voider: 'Voided by',
                    void_remarks: 'Reason',
                    payment_type: 'Payment Type',
                    total_amount: 'Total Amount (RM)',
                    till_closure: 'Till Closure No.',
                    till_summary: 'Till Summary No.',
                    voided_at: 'Voided At',
                },
                texts: {
                    title: 'Voided Receipts',
                    description:
                        'Shows list of voided C-store and fuel receipts',
                },
                templates: {
                    sequence_number: (h, row) => {
                        return this.receiptNumberFormat(row);
                    },
                    settled_date: (h, row) => {
                        return this.receiptDateFormat(row.settled_date);
                    },
                    voided_at: (h, row) => {
                        return this.receiptDateFormat(row.voided_at);
                    },
                    void_remarks(h, row) {
                        return require('./void-remarks.jsx')(h, row);
                    },
                    outlet_name: (h, row) => {
                        return row.outlet_name.substring(0, 20);
                    },
                },
                rowClassCallback: row => 'pointer',
                rowClickCallback: row => {
                    this.showReceipt(row.id, null, true);
                },
                pdf_url: Laroute.route(
                    'franchise.report.voidedsales.exportAsFile',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.voidedsales.exportAsFile',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.voidedsales.exportAsFile',
                    { type: 'XLSX' },
                ),
                columnsClasses: {
                    total_amount: 'text-right',
                },
                orderBy: {
                    ascending: false,
                    column: 'voided_at',
                },
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),

        datatableUrl() {
            return Laroute.route('franchise.report.voidedsales.index');
        },

        getActiveOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },

        getActiveOutlet() {
            this.setColumnDisplay();
        },
    },

    mounted() {
        this.setColumnDisplay();
    },

    created() {
        this.removeLimitState();
        window.addEventListener('beforeunload', this.removeLimitState);
    },

    methods: {
        refresh() {
            this.$refs.datatable.getData();
        },

        showReceipt(transaction_id, refund_id = null, voided = false) {
            this.$refs.receipt.$emit(
                'show-receipt',
                transaction_id,
                refund_id,
                voided,
            );
        },

        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },

        removeLimitState() {
            let query = JSON.parse(
                localStorage.getItem(`vuetables_${this.tableName}`),
            );

            if (!_.isNull(query) && !_.isUndefined(query.perPage)) {
                query.perPage = 20;

                localStorage.setItem(
                    `vuetables_${this.tableName}`,
                    JSON.stringify(query),
                );
            }
        },

        setColumnDisplay() {
            this.$refs.datatable.userControlsColumns = true;

            if (this.getActiveOutlet != 0) {
                this.$refs.datatable.userColumnsDisplay = [
                    'voided_at',
                    'settled_date',
                    'sequence_number',
                    'voider',
                    'void_remarks',
                    'till_closure',
                    'till_summary',
                    'cashier',
                    'payment_type',
                    'table_name',
                    'pax',
                    'total_amount',
                ];
            } else {
                this.$refs.datatable.userColumnsDisplay = this.columns;
            }
        },
    },
};
</script>

<style>
.italic {
    font-style: italic;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/voided/vuetable_voided.vue